import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const WritingPage = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-683">
      <Header data-id="element-684" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-685">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-686">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-687">
            <Navigation data-id="element-688" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-689">
            <div className="max-w-2xl" data-id="element-690">
              <ul className="list-none leading-tight" data-id="element-691">
                <li className="mb-[0.2rem]" data-id="element-692">
                  <Link to="/giovannitti-needs-god" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-693">
                    Giovannitti Needs God (Interview, <em data-id="element-694">Badlon Magazine</em>{' '}
                    2025)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-695">
                  <a href="https://blog.photoeye.com/2025/04/emerald-drifters-reviewed-by-madeleine.html" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-696">
                    Emerald Drifters (Review, <em data-id="element-697">Photo-Eye</em> 2025)
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WritingPage;